const getPathFromUrl = (url) => {
    if (!url) {
        return;
    }
    if (url.indexOf('://') === -1) {
        return url;
    }
    const urlObject = new URL(url);
    return urlObject.pathname + urlObject.search + urlObject.hash;
};

const NAJA_ATTRIBUTE_SELECTOR = 'data-naja-spinner-selector';

export class LoaderExtension {
    constructor(spinnerSelector, uiBlocker, displayErrorHandler) {
        this.loaders = [];
        this.unblockAll = 'off';
        this.spinnerSelector = spinnerSelector;
        this.uiBlocker = uiBlocker;
        this.displayErrorHandler = displayErrorHandler;
    }

    initialize(naja) {
        naja.addEventListener('init', () => {
            this.loader = document.querySelector(this.spinnerSelector);
        });

        naja.uiHandler.addEventListener('interaction', this.saveLoaders.bind(this));
        naja.addEventListener('before', this.saveLoadersFromOptions.bind(this));
        naja.addEventListener('start', this.showLoader.bind(this));
        naja.addEventListener('complete', this.hideLoader.bind(this));
        naja.addEventListener('abort', this.hideLoader.bind(this));
        naja.addEventListener('error', this.showError.bind(this));
    }

    addLoader(element, url, initialized) {
        this.loaders.push({ element, url, initialized });
    }

    saveLoaders(event) {
        const element = event.detail.element;

        // Element ma attribut blokujici naju -> nevytvorime spinner
        if (element.hasAttribute('data-naja-disabled')) {
            return;
        }

        // Pokud ma element svoj atribut, pouzijeme ten
        const selector = element.hasAttribute(NAJA_ATTRIBUTE_SELECTOR)
            ? element.getAttribute(NAJA_ATTRIBUTE_SELECTOR)
            : // Jinak pokud ma nadrazeny form atribut, pouzijeme ten
            element.form && element.form.hasAttribute(NAJA_ATTRIBUTE_SELECTOR)
            ? element.form.getAttribute(NAJA_ATTRIBUTE_SELECTOR)
            : null;

        this.addLoader(
            selector || (element.form ? element.form : element),
            element.form
                ? getPathFromUrl(event.detail.url || element.form.action)
                : getPathFromUrl(event.detail.url || element.href || element.action || element.baseURI),
            false
        );

        // Stav on už se nemění až do odblokování
        if (this.unblockAll !== 'on') {
            this.unblockAll = element.getAttribute('data-naja-unblock-all');
        }
    }

    saveLoadersFromOptions(event) {
        if (event !== undefined && event.detail.options !== undefined) {
            if (event.detail.options.spinnerSelector !== undefined) {
                this.addLoader(event.detail.options.spinnerSelector, getPathFromUrl(event.detail.url), false);
            }

            if (event.detail.options.unblockAll !== undefined) {
                // Stav on už se nemění až do odblokování
                if (this.unblockAll !== 'on') {
                    this.unblockAll = event.detail.options.unblockAll;
                }
            }
        }
    }

    showLoader(event) {
        if (!this.loaders.length) {
            return;
        }

        const unInitializedLoaders = this.loaders.filter((filter) => !filter.initialized);

        unInitializedLoaders.forEach((loader, index, unInitializedLoaders) => {
            this.uiBlocker.block(loader.element);
            loader.initialized = true;

            if (!event.detail.request.onabort) {
                event.detail.request.onabort = () => {
                    this.uiBlocker.unblock(loader.element);
                    unInitializedLoaders.splice(index, 1);
                };
            }
        });
    }

    hideLoader(event) {
        if (!this.loaders.length) {
            return;
        }

        // Ukončeno bez odpovědi - při abortu, když se request vyvolá znovu - nemáme url
        if (!event.detail.response || !event.detail.response.url) {
            return;
        }

        const url = getPathFromUrl(event.detail.response.url);

        // Pokud přijde z API response bez erroru, ale máme již zobrazený error alert, tak ho skryjeme
        if (this.displayErrorHandler && !event.detail.error) {
            this.displayErrorHandler.hideError();
        }

        // Bude se dělat redirect - nic nebudeme skrývat, aby to nebylo chvíli před načtením nové stránky uvolněno
        if (
            event.detail.payload &&
            event.detail.payload.redirect &&
            event.detail.options &&
            event.detail.options.forceRedirect
        ) {
            return;
        }

        this.loaders.forEach((loader, index, loadersWithResponseUrl) => {
            // Pokud máme odblokovat vše, učiníme tak (hodí se tam, kde se URL mění)
            if (this.unblockAll === 'on') {
                this.uiBlocker.unblockAll();
                this.unblockAll = 'off';
            } else if (loader.url === url) {
                try {
                    this.uiBlocker.unblock(loader.element);
                } catch (e) {
                    // Element uz neexistuje, odstranime vsechny spinnery, aby tam nezustaly viset
                    console.warn(e);
                    console.warn('Unblocking all elements');
                    this.uiBlocker.unblockAll();
                }
                loadersWithResponseUrl.splice(index, 1);
            }
        });
    }

    showError(event) {
        this.uiBlocker.unblockAll();

        if (event.detail.options !== undefined && event.detail.options.silentError === true) {
            return;
        }

        if (this.displayErrorHandler) {
            this.displayErrorHandler.displayError(event.detail.error ? event.detail.error.message : 'Unknown error');
        }

        console.error('error', event, event.detail);
    }
}
